let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("34mYp")).then(() => parcelRequire('4V9Yp'));